import axios from "axios";
import BaseService from "./BaseService";
let fileTypes = {
  'text/html':'html',
  'text/xml':  'xml',
  'text/plain':'txt',
  'image/png': 'png',
  'image/tiff':'tif tiff',
  'image/vnd.wap.wbmp':'wbmp',
  'image/x-icon':'ico',
  'image/x-jng': 'jng',
  'image/x-ms-bmp':'bmp',
  'image/svg+xml':'svg',
  'image/webp':'webp',
  'application/msword':'doc',
  'application/pdf':'pdf',
  'application/rtf':'rtf',
  'application/vnd.ms-excel':'xls',
  'application/vnd.ms-powerpoint':'ppt',
  'default': 'txt'
}
class FileService  extends BaseService {


  async uploadFile(fileData) {
    try {
      let data = new FormData();
      data.append('file', fileData.file);
      data.append('name', fileData.name);
      data.append('public', fileData.public);
      let res = await axios.post('/files/upload', data);
      return res;
    } catch (e) {
      this._handleError({translationKey: 'image.upload.error', error: e});
      throw e;
    }
  }

  /**
   * Downloads a given Blob in a new browser tab
   * @param {Blob} blob
   * @param {string} fileName
   */
  downloadFileInBrowser(blob, fileName) {
    const url = window.URL.createObjectURL(new Blob([blob]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
  }

  async downloadFile(token, filename) {
    let res = await axios.get(`/files/download/${token}`, {responseType: 'blob'});
    let type = res.type
    let extension = fileTypes[type] || fileTypes.default
    this.downloadFileInBrowser(res, `${filename}.${extension}`)
  }


}

export default new FileService();
